export default (() => ({
  global: {
    layerBackground: -1,
    // For a background element below another nearby
    layerReset: 0,
    // For creating a new stacking context
    layerOverlay: 1,
    // For overlaying an element on top of another nearby
    layerPopout: 50,
    // For dropdowns and popup boxes
    layerTooltip: 100,
    // For tooltips, help popups
    layerFloating: 200,
    // For widgets or sidebars that stick to the side of the screen
    layerModal: 10000 // For entire screen-filling overlays
  }
}));